<template>
    <a class="btn btn-warning e2e-restart-exercise"
       @click.stop.prevent="onRestartExercise">
          <i class="fa fa-refresh" aria-hidden="true"></i>
          {{fragment.text}}
    </a>
</template>

<script>
export default {
  name: "fragment-restart-exercise",
  props: ["fragment"],
  methods: {
    async onRestartExercise() {
      this.$store.dispatch("sendRestartExercise");
    }
  }
};
</script>
 

<style scoped>
</style>